import type { TranscribeAudio } from "@productlane/ui/src/components/use-audio-input"

import { env } from "@/env"

export const transcribeAssistantAudio: TranscribeAudio = async (
	audio,
	signal,
) => {
	const response = await fetch(`${env.VITE_API_URL}/api/sidebar/transcribe`, {
		method: "POST",
		credentials: "include",
		headers: { "Content-Type": audio.type },
		body: audio,
		signal,
	})
	const result = (await response.json().catch(() => ({}))) as {
		text?: unknown
		message?: unknown
	}
	if (!response.ok || typeof result.text !== "string")
		throw new Error(
			typeof result.message === "string"
				? result.message
				: "Transcription failed. Please try again.",
		)
	return result.text
}
